import * as Sentry from '@sentry/react';
import {router} from 'Routes/routes';
import './index.module.scss';
import PageLoading from 'components/PageLoading';
import {RouterProvider} from 'react-router-dom';
import {SWRConfig} from 'swr';
import {captureApiError} from 'utils/setup/setupSentry';

function App(): JSX.Element {
  return (
    <SWRConfig value={{onError: captureApiError}}>
      <RouterProvider router={router} fallbackElement={<PageLoading />} />
    </SWRConfig>
  );
}

export default Sentry.withProfiler(App);
